import React, { useState } from "react";
import CrossIcon from "../../../../assets/icons/maid-module-icons/CrossBtn.svg";

const FilterModal = ({ showFilter, setShowFilter, onApply }) => {
  const [selectedDate, setSelectedDate] = useState("Today");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [error, setError]  = useState("");
  const [status, setStatus]  = useState("");

  const handleDateOption = (option) => {
    setSelectedDate(option);
    setStartDate("");
    setEndDate("");
    setError("");
  };

  const handleStartDate = (value) => {
    setStartDate(value);
    setError("");
    if (endDate) {
      const diff = (new Date(endDate) - new Date(value)) / (1000 * 60 * 60 * 24);
      if (diff < 0)    setError("Start date cannot be after end date.");
      else if (diff > 31) setError("Custom range cannot exceed 31 days.");
    }
  };

  const handleEndDate = (value) => {
    setEndDate(value);
    setError("");
    if (startDate) {
      const diff = (new Date(value) - new Date(startDate)) / (1000 * 60 * 60 * 24);
      if (diff < 0)    setError("End date cannot be before start date.");
      else if (diff > 31) setError("Custom range cannot exceed 31 days.");
    }
  };

  const handleApply = () => {
    const payload = {};

    if (selectedDate === "Today") {
      // Only startDt, no endDt
      payload.startDt = new Date().toISOString();

    } else if (selectedDate === "Yesterday") {
      // Only startDt (yesterday), no endDt
      const y = new Date();
      y.setDate(y.getDate() - 1);
      payload.startDt = y.toISOString();

    } else {
      // Custom: validate then send both startDt and endDt
      if (!startDate || !endDate) { setError("Please select both start and end dates."); return; }
      const diff = (new Date(endDate) - new Date(startDate)) / (1000 * 60 * 60 * 24);
      if (diff < 0)  { setError("Start date cannot be after end date."); return; }
      if (diff > 31) { setError("Custom range cannot exceed 31 days."); return; }
      payload.startDt = new Date(startDate + "T00:00:00").toISOString();
      payload.endDt   = new Date(endDate + "T23:59:59").toISOString();
    }

    // isCurrentlyIn: 1 | 0 | null
    if (status === "Currently In")       payload.isCurrentlyIn = true;
    else if (status === "Currently Out") payload.isCurrentlyIn = false;
    else                                 payload.isCurrentlyIn = null;

    if (onApply) onApply(payload);
    setShowFilter(false);
  };

  const handleClose = () => { setError(""); setShowFilter(false); };

  const dateButtons = [
    { label: "Today",     value: "Today" },
    { label: "Yesterday", value: "Yesterday" },
    { label: "Custom",    value: "Custom" },
  ];

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: showFilter ? "flex" : "none", justifyContent: "center", alignItems: "center", zIndex: 1300 }}>
      <div style={{ width: "340px", background: "#fff", borderRadius: "20px", overflow: "hidden", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" }}>

        {/* Header */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 20px 12px 20px", position: "relative" }}>
          <span style={{ fontWeight: 800, fontSize: 20, color: "#000" }}>Filter</span>
          <button
            onClick={handleClose}
            style={{ position: "absolute", right: 16, top: "50%", transform: "translateY(-50%)", width: 25, height: 32, borderRadius: 8, background: "#2F80C0", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
          >
            <img src={CrossIcon} alt="cross" style={{ height: "14px", width: "14px" }} />
          </button>
        </div>

        <div style={{ height: "1px", background: "#E8E8E8", margin: "0 0 16px 0" }} />

        {/* Body */}
        <div style={{ padding: "0 20px 20px 20px" }}>

          <div style={{ fontWeight: 600, fontSize: 15, color: "#111", marginBottom: 12 }}>Date</div>

          {/* Today / Yesterday / Custom */}
          <div style={{ display: "flex", gap: "10px", marginBottom: 16 }}>
            {dateButtons.map((btn) => (
              <button
                key={btn.value}
                onClick={() => handleDateOption(btn.value)}
                style={{
                  flex: 1, padding: "10px 0", borderRadius: "10px", fontSize: "14px",
                  border: selectedDate === btn.value ? "1.5px solid #2F80C0" : "1.5px solid #D0D0D0",
                  background: "#fff",
                  color: selectedDate === btn.value ? "#2F80C0" : "#333",
                  fontWeight: selectedDate === btn.value ? 600 : 400,
                  cursor: "pointer",
                }}
              >
                {btn.label}
              </button>
            ))}
          </div>

          {/* Start / End date — enabled only for Custom */}
          <div style={{ display: "flex", gap: "12px", marginBottom: 8 }}>
            <input
              type="date"
              value={startDate}
              onChange={(e) => handleStartDate(e.target.value)}
              disabled={selectedDate !== "Custom"}
              style={{
                flex: 1, padding: "10px 12px", borderRadius: "10px",
                border: "1.5px solid #D0D0D0", fontSize: 14,
                background: selectedDate !== "Custom" ? "#F5F5F5" : "#fff",
                cursor: selectedDate !== "Custom" ? "not-allowed" : "pointer",
                outline: "none",
              }}
            />
            <input
              type="date"
              value={endDate}
              onChange={(e) => handleEndDate(e.target.value)}
              disabled={selectedDate !== "Custom"}
              style={{
                flex: 1, padding: "10px 12px", borderRadius: "10px",
                border: "1.5px solid #D0D0D0", fontSize: 14,
                background: selectedDate !== "Custom" ? "#F5F5F5" : "#fff",
                cursor: selectedDate !== "Custom" ? "not-allowed" : "pointer",
                outline: "none",
              }}
            />
          </div>

          {/* Currently In / Currently Out — toggle off on re-click */}
          <div style={{ display: "flex", gap: "10px", marginTop: 12 }}>
            {["Currently In", "Currently Out"].map((item) => (
              <button
                key={item}
                onClick={() => setStatus(prev => prev === item ? "" : item)}
                style={{
                  flex: 1, padding: "10px 0", borderRadius: "10px", fontSize: 14,
                  border: status === item ? "1.5px solid #2F80C0" : "1.5px solid #D0D0D0",
                  background: "#fff",
                  color: status === item ? "#2F80C0" : "#333",
                  fontWeight: status === item ? 600 : 400,
                  cursor: "pointer",
                }}
              >
                {item}
              </button>
            ))}
          </div>

          {error && <div style={{ color: "#E53935", fontSize: 12, marginTop: 8 }}>{error}</div>}

          <div style={{ marginTop: "20px" }}>
            <button
              onClick={handleApply}
              style={{ width: "100%", padding: "12px", borderRadius: "30px", border: "none", background: "#2F80C0", color: "#fff", fontWeight: 600, cursor: "pointer", fontSize: 15 }}
            >
              Apply Filter
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FilterModal;